import React from 'react';

import css from './Testimonial.module.scss';

interface Props {
  quote: string;
  author: string;
  location: string;
  design: string | undefined;
}

const Testimonial = ({
  quote,
  author,
  location,
  design = 'default'
}: Props) => {
  const locationText = `, ${location}`;
  return (
    <div
      className={`${css.testimonial} ${css[design]}`}
      data-testid={`testimonial-${design}`}
    >
      <img
        src={`/static/testimonial-quote-${design}.svg`}
        alt="Testimonial quote"
      />
      <p>{quote}</p>
      <p>
        <span>{author}</span>
        {location && locationText}
      </p>
    </div>
  );
};

export default Testimonial;
